import { zonedTimeToUtc } from "date-fns-tz";

export const CREATE_AI_NEW_UNTIL_MILLIS = zonedTimeToUtc("2027-01-07T00:00", "Europe/Brussels").getTime();
export const CREATE_TAB_NEW_UNTIL_MILLIS = zonedTimeToUtc("2027-01-07T00:00", "Europe/Brussels").getTime();
